// removed by extract-text-webpack-plugin
module.exports = {"year":"src-components----YearChange-module---year---2stPN","text":"src-components----YearChange-module---text---LHghn","arrow":"src-components----YearChange-module---arrow---2oHr6","arrowInactive":"src-components----YearChange-module---arrowInactive---n02bn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/YearChange.module.css
// module id = 190
// module chunks = 168707334958949